"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCorporateFees = void 0;
const enums_1 = require("../../types/enums");
const constants_1 = require("../../constants");
const CORPORATE_PROVIDER_RATES = {
    [enums_1.DonationProvider.PayPal]: {
        base: 0.75,
    },
    [enums_1.DonationProvider.GiveIndia]: {
        base: 5,
        cap: 7.5,
    },
    [enums_1.DonationProvider.GlobalGiving]: {
        base: 5,
    },
    [enums_1.DonationProvider.NFG]: {
        base: 2.25,
        cap: 5,
    },
    [enums_1.DonationProvider.CAF]: {
        cap: 5,
    },
    [enums_1.DonationProvider.Give2Asia]: {
        base: 5,
        cap: 7.5,
    },
};
/**
 * Calculates fee structure for corporate donations based on provider
 */
const getCorporateFees = ({ donationProvider, includeDeedFee = true, applicationFeeSetting = constants_1.DEFAULT_APPLICATION_FEE_CORPORATE, }) => {
    if (!donationProvider) {
        throw new Error('Donation provider is required');
    }
    // In the context of corporate donations, applicationFeeSetting actually means total fee.
    const totalFeeRate = applicationFeeSetting;
    // PayPal base PPGF Rate
    const { base: paypalBase } = CORPORATE_PROVIDER_RATES.PayPal;
    /**
     * GiveIndia: Total 7.5% split between provider, PayPal, and application
     */
    const calculateGiveIndia = () => {
        const { base, cap } = CORPORATE_PROVIDER_RATES.GiveIndia;
        return {
            applicationFee: cap - base - paypalBase,
            providerFee: base + paypalBase,
            ppgfFee: paypalBase,
        };
    };
    /**
     * GlobalGiving: Fixed 5% platform fee
     */
    const calculateGlobalGiving = () => {
        const { base } = CORPORATE_PROVIDER_RATES.GlobalGiving;
        return {
            applicationFee: 0,
            providerFee: base,
        };
    };
    /**
     * PayPal: Variable total fee split between PayPal and application
     */
    const calculatePayPal = () => ({
        applicationFee: includeDeedFee ? Math.max(totalFeeRate - paypalBase, 0) : 0,
        providerFee: Math.min(totalFeeRate, paypalBase),
    });
    /**
     * NFG: Total 5% split between provider, PayPal, and application
     */
    const calculateNFG = () => {
        const { base, cap } = CORPORATE_PROVIDER_RATES.NFG;
        return {
            applicationFee: includeDeedFee ? cap - base - paypalBase : 0,
            providerFee: base + paypalBase,
            ppgfFee: paypalBase,
        };
    };
    /**
     * CAF: Total 5% split between PayPal and application (which is then split between CAF and Deed)
     */
    const calculateCAF = () => {
        const { cap } = CORPORATE_PROVIDER_RATES.CAF;
        return {
            applicationFee: includeDeedFee ? cap - paypalBase : 0,
            providerFee: paypalBase,
        };
    };
    /**
     * CAF: Total 5% split between PayPal and application (which is then split between CAF and Deed)
     */
    const calculateGive2Asia = () => {
        const { cap } = CORPORATE_PROVIDER_RATES.Give2Asia;
        return {
            applicationFee: includeDeedFee ? cap - paypalBase : 0,
            providerFee: paypalBase,
        };
    };
    switch (donationProvider) {
        case enums_1.DonationProvider.GiveIndia:
            return calculateGiveIndia();
        case enums_1.DonationProvider.GlobalGiving:
            return calculateGlobalGiving();
        case enums_1.DonationProvider.PayPal:
            return calculatePayPal();
        case enums_1.DonationProvider.NFG:
            return calculateNFG();
        case enums_1.DonationProvider.CAF:
            return calculateCAF();
        case enums_1.DonationProvider.Give2Asia:
            return calculateGive2Asia();
        default:
            throw new Error(`Donation provider ${donationProvider} is not supported`);
    }
};
exports.getCorporateFees = getCorporateFees;
//# sourceMappingURL=getCorporateFees.js.map